import { CollectionEntriesRepository } from '@lib/api/repository/collection-entries';
import {
  CollectionEntryJob,
  CollectionEntryQuery,
} from '@lib/types/collection-entries';

import { Requester } from '../clients';

const path = (collectionId: string) =>
  `/marketplace/admin/catalog/collections/${collectionId}/entries`;

const LATEST_JOB = 'latest';

export default class CollectionEntriesAPI implements CollectionEntriesRepository {
  async start(collectionId: string) {
    const { data } = await Requester.post<CollectionEntryJob>(
      path(collectionId),
    );

    return data;
  }

  async find(input: CollectionEntryQuery, signal?: AbortSignal) {
    const { data } = await Requester.get<CollectionEntryJob | null>(
      `${path(input.collectionId)}/${input.jobId ?? LATEST_JOB}?page=${input.page ?? 1}`,
      { signal },
    );

    return data;
  }
}
